import { makeAutoObservable, runInAction } from 'mobx';
import { IRootStore } from '../models/stores/root.models';
import { IGetUserCodeParam, IUserCode, IUserCodeInfo, IUserCodeStore } from '../models/stores/user-codes.models';
import { SupportBackendRoutes } from '../routes/backend.routes';

export class UserCodes implements IUserCodeStore {

  public readonly rootStore: IRootStore;
  public loading: boolean = false;
  public codeItems: IUserCode[] | null = null;
  public codeItemsInfo: IUserCodeInfo[] | null = null;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this, {
      rootStore: false,
    });
  }

  public async getUserCodes(request: IGetUserCodeParam): Promise<void> {
    try {
      runInAction(() => {
        this.loading = true;
        this.codeItems = null;
      });

      const response = await this.rootStore.requests.json<IUserCode[]>({
        method: 'GET',
        baseURL: this.rootStore.config.supportAPI,
        route: SupportBackendRoutes.getUserCode,
        token: this.rootStore.user.token,
        params: request,
      });

      runInAction(() => {
        this.loading = false;
        this.codeItems = response;
      });
    }
    catch (error) {
      runInAction(() => {
        this.loading = false;
        this.codeItems = null;
        this.rootStore.errors.setError(error);
      });
    }
  }

  public async getUserCodesInfo(request: IGetUserCodeParam): Promise<void> {
    try {
      runInAction(() => {
        this.codeItemsInfo = null;
        this.loading = true;
      });

      const response = await this.rootStore.requests.json<IUserCodeInfo[]>({
        method: 'GET',
        baseURL: this.rootStore.config.supportAPI,
        route: SupportBackendRoutes.getUserCodeInfo,
        token: this.rootStore.user.token,
        params: request,
      });

      runInAction(() => {
        this.codeItemsInfo = response;
        this.loading = false;
      });
    }
    catch (error) {
      runInAction(() => {
        this.codeItems = null;
        this.loading = false;
        this.rootStore.errors.setError(error);
      });
    }
  }

}
